import axios from 'axios'
import * as storage from '../Services/storage.jsx'
import { getHubspotApiUrl } from './helpers.jsx'

const HB_TIMEOUT = 600000

export const hb_trackQuotesFromLocalStorage = async (email) => {
  try {
    const storageQuotes = storage.hb_getAllInstantQuote()

    const promises = []
    for (const quoteCode in storageQuotes) {
      const storageQuote = storageQuotes[quoteCode]
      promises.push(hb_trackQuote(email, quoteCode, storageQuote))
    }

    const responses = await axios.all(promises)

    for (const response of responses)
      if (response && response.status == 200)
        storage.hb_deleteInstantQuote(response.config.params.id)

    return true
  } catch (error) {
    console.error(error)
  }
}

export const hb_trackSignup = async (
  email,
  firstName,
  lastName,
  lang,
  country,
  city,
) => {
  try {
    const params = {email, firstName, lastName, lang, country, city, id: email}
    const result = await axios.get(getHubspotApiUrl() + '/trackSignup', {
      params,
      timeout: HB_TIMEOUT,
    })
    return result
  } catch (error) {
    console.error(error)
  }
}

export const hb_trackPurchase = async (email, pid, price, projectEmail) => {
  try {
    const params = {email, pid, price, id: pid, projectEmail}
    const result = await axios.get(getHubspotApiUrl() + '/trackPurchase', {
      params,
      timeout: HB_TIMEOUT,
    })
    return result
  } catch (error) {
    console.error(error)
  }
}

export const hb_trackQuote = async (email, quoteCode, quote) => {
  const selected_delivery_date = quote.deliveryDate.isAuto
    ? 'auto'
    : quote.deliveryDate.date
  // tofix: ask antonio if he needs just a string or a json => const target_languages = quote.targetLanguages.map(({ id }) => id)).join(',');
  const target_languages = JSON.stringify(
    quote.targetLanguages.map(({id}) => id),
  ) // collect id of target languages in an array and make it a string

  const params = {
    email,
    source: quote.sourceLanguage.id,
    target: target_languages,
    words: quote.wordCount,
    subject: quote.subject.id,
    selected_delivery_date: selected_delivery_date,
    quoteTimestamp: quote.timestamp,
    id: quoteCode,
  }

  try {
    const result = await axios.get(getHubspotApiUrl() + '/trackQuote', {
      params,
      timeout: HB_TIMEOUT,
    })
    return result
  } catch (error) {
    console.error(error)
  }
}
